// # Applications
// handles the notification actions for the redux store
// import dependencies
import types from "../constants/types";

export const setApiKeys = payload => ({
    "type": types.SET_APIKEYS,
    payload
});
